import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import { withHandlers } from 'recompose';

import noop from 'app/libs/noop';
import localizeLink from 'app/features/localization/localizeLink';
import withAppName from 'app/enhancers/withAppName';
import withLocale from 'app/features/localization/enhancers/withLocale';
import isUrl from 'app/router/helpers/isUrl';

const LocalizedLink = ({
  locale,
  appName,
  to,
  handleClick,
  children,
  className,
  testId,
}) => {
  const isExternal = isUrl(to);
  const As = isExternal ? 'a' : Link;
  const path = isExternal ? to : `/${appName}${to}`;
  const props = {
    onClick: handleClick,
    className,
    [isExternal ? 'href' : 'to']: isExternal
      ? localizeLink(path, '')
      : localizeLink(path, locale),
    ...(testId && { 'data-t': testId }),
  };

  return <As {...props}>{children}</As>;
};

const handleClick =
  ({ to, onClick = noop }) =>
  e => {
    onClick(e);

    if (to.startsWith('#')) {
      e.preventDefault();

      document.getElementById(to).scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

LocalizedLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
  locale: PropTypes.string,
  className: PropTypes.string,
  handleClick: PropTypes.func,
  testId: PropTypes.string,
};

LocalizedLink.defaultProps = {
  handleClick: noop,
  className: '',
  locale: '',
  testId: '',
};

export { handleClick };

export default compose(
  withLocale,
  withAppName,
  withHandlers({ handleClick }),
)(LocalizedLink);
